/**
* A Chebyshev polynomial
*/
export class Chebyshev {
    private order: number;
    private components: number;
    private startTime: number;
    private endTime: number;
    private coeffs: number[];
    private midTime: number;
    private halfTime: number;

    /**
    * Creates an instance of Chebyshev polynomial
    * 
    * @constructor
    */
    constructor(json: any) {
        this.order = json.order;
        this.components = json.components;
        this.startTime = json.startTime;
        this.endTime = json.endTime;
        this.coeffs = json.coeffs;
        this.midTime = (this.endTime + this.startTime) / 2;
        this.halfTime = (this.endTime - this.startTime) / 2;
    }

    evaluate(x: number): number[] {
        if (x < this.startTime || x > this.endTime) {
            throw new RangeError();
        }

        let retVals: number[] = [];
        let xx = (x - this.midTime) / this.halfTime;
        let xx2 = 2 * xx;

        //compute values of Chebyshev polynomials themselves as t
        let T: number[] = [];
        T.push(1);
        T.push(xx);
        for (let j = 2; j <= this.order; j++) {
            T.push(xx2 * T[j - 1] - T[j - 2]);
        }

        //compute the value of each component from the Chebyshev polynomials and their coefficients
        for (let c = 0; c < this.components; c++) {
            retVals[c] = 0.5 * this.coeffs[c * (this.order + 1)];
            for (let j = 1; j <= this.order; j++) {
                retVals[c] += this.coeffs[c * (this.order + 1) + j] * T[j];
            }
        }

        return retVals;
    }
}



// WEBPACK FOOTER //
// ./src/Chebyshev.ts